import { createWorkers } from "./utils";
import { aggregatedSumTotalRow } from "@workers/row-aggregator.worker";
import { TCommonRowData, TCommonRowObj } from "./common-types";
import { ColDef } from "ag-grid-community";

/*
 ! Note !
 * Workers is executing twice, also for every process also, every time grid is rendered.
 * The aggregation is performed, for which we are trying to store the aggregated data in redux states,
 * and perform a check using it. 
 */

//! api is kept any as some of the methods types given by ag-grid is private and we are unable to use it
export async function populateTotalRow({
    api,
    data,
}: {
    api: any;
    data: TCommonRowData;
}) {
    
    data = data || [];

    if(data.length){

    if (Object.keys(data).length !== 0) {
        const changed = api.context.oldRowsToDisplay
            ? api.context.oldRowsToDisplay.length === data.length &&
              !!data.find(
                  (curr: TCommonRowObj, i: number) =>
                      curr !== api.context.oldRowsToDisplay[i]
              )
            : true;
        if (!changed) return;
        else if (data.length === 0) return api.setPinnedTopRowData([]);
        const pinnedData = await (window.Worker
            ? createWorkers("aggregate", data)
            : aggregatedSumTotalRow(data));

        api.columnModel.columnDefs.forEach((col: ColDef) => {
            pinnedData[col.field] =
                col.cellRendererParams &&
                col.cellRendererParams.hasPinnedColumnValue
                    ? col.cellRendererParams.pinnedColumnValue ||
                    pinnedData[col.field]
                    : "";
        });

        api.setPinnedTopRowData([pinnedData]);
    }
    }

}
